<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: 100%;margin: 0 20px">
      <div style="height: 40px;padding-top: 20px">
        <el-button size="small" type="primary" plain icon="el-icon-plus" @click="addNewOrg()">新增</el-button>
        <el-input size="small" prefix-icon="el-icon-search" placeholder="输入名称搜索" v-model="searchKeyword" clearable style="width: 250px"></el-input>
      </div>
      <div style="max-height: calc(100% - 110px);overflow-y: auto">
        <el-table :data="tbdata" border style="width: 100%" highlight-current-row ref="singleTable">
          <el-table-column
            type="index"
            label="序号"
            width="50">
          </el-table-column>
          <el-table-column
            label="类型"
            min-width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.org_type === 2">楼层</span>
              <span v-if="scope.row.org_type === 1">楼栋</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="名称"
            min-width="80">
          </el-table-column>
          <el-table-column
            label="所属上级"
            min-width="70">
            <template slot-scope="scope">
              {{getOrgpidName(scope.row)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="createtime"
            label="录入时间"
            min-width="90">
          </el-table-column>
          <el-table-column align="center" label="操作" width="130"  class-name="small-padding fixed-width">
            <template slot-scope="scope">
              <i title="更新" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editOrg(scope.row)"></i>
              <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delOrg(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="text-align: center;margin-top: 10px;height: 40px;">
        <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper"
                       :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells">
        </el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="500px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div><span>{{ addEditTitle }}</span></div>
        <div class="line-title"></div>
        <add-edit-build :orgRow="orgRow" v-model="addEditShow" @changeAddEdit="changeAddEdit"></add-edit-build>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {deleteorg, queryorg} from '../../api/organizer'
import addEditBuild from './components/addEditBuild'
export default {
  name: 'buildingLayer',
  components: {addEditBuild},
  data () {
    return {
      searchKeyword: '',
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      orgArr: [],
      addEditTitle: '',
      addEditShow: false,
      orgRow: {
        isAdd: true,
        orgArrEnd: [],
        orgArr1: [],
        orgArr2: [],
        row: ''
      }
    }
  },
  created () {
    this.getOrgData()
  },
  computed: {
    tbdata () {
      return this.searchFilterWord()
    }
  },
  methods: {
    // 组织
    getOrgData () {
      this.tableData = []
      this.orgRow.orgArr1 = []
      this.orgRow.orgArr2 = []
      queryorg().then(res => {
        this.orgArr = this.clone(res.data.org)
        for (let i = 0; i < this.orgArr.length; i++) {
          if (this.orgArr[i].org_type === 0) {
            this.orgRow.orgArr1.push(this.orgArr[i])
          }
          if (this.orgArr[i].org_type === 0 || this.orgArr[i].org_type === 1) {
            let obj = this.clone(this.orgArr[i])
            if (this.orgArr[i].org_type === 0) {
              obj.disabled = true
            } else {
              obj.disabled = false
            }
            this.orgRow.orgArr2.push(obj)
          }
        }
        for (let i = 0; i < this.orgArr.length; i++) {
          if (this.orgArr[i].org_type === 1 || this.orgArr[i].org_type === 2) {
            this.tableData.push(this.orgArr[i])
          }
        }
        this.getOrTree1()
        // console.log(this.tableData)
      }).catch(() => {})
    },
    getOrTree1 () {
      // 所属组织
      let lastLevel = 100
      const arr = this.orgRow.orgArr1
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level < lastLevel) {
          lastLevel = arr[i].level
        }
      }
      let treeData = []
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level === lastLevel) {
          treeData.push(arr[i])
        }
      }
      for (let i = 0; i < treeData.length; i++) {
        const child = this.arrayToNode1(arr, treeData[i].id)
        if (child.length !== 0) {
          treeData[i].child = child
        }
      }
      // console.log(999, arr, treeData)
      this.orgRow.orgArrEnd = treeData
    },
    arrayToNode1 (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode1(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    // table数据入口（tbdata）
    searchFilterWord () {
      const data = this.tableData
      const vm = this
      const search = data.filter((val) => {
        if (val.name.includes(vm.searchKeyword)) {
          return true
        }
      })
      vm.totalCells = search.length
      const arr = []
      for (let i = (vm.currentPage - 1) * vm.pageSize; i < vm.currentPage * vm.pageSize; i++) {
        if (!search[i]) {
          break
        }
        arr.push(search[i])
      }
      return arr
    },
    // 表格
    getOrgpidName (row) {
      for (let i = 0; i < this.orgArr.length; i++) {
        if (row.orgpid === this.orgArr[i].id) {
          return this.orgArr[i].name
        }
      }
    },
    // 新增
    addNewOrg () {
      this.addEditTitle = '新增楼栋楼层'
      this.orgRow.isAdd = true
      this.orgRow.row = ''
      this.addEditShow = true
    },
    // 编辑
    editOrg (row) {
      this.addEditTitle = '编辑楼栋楼层'
      this.orgRow.isAdd = false
      this.orgRow.row = row
      this.addEditShow = true
    },
    // 删除
    delOrg (row) {
      let name = row.name
      this.$confirm('此操作将永久删除【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          orgids: [row.id]
        }
        deleteorg(data).then(() => {
          this.getOrgData()
          this.$notify({
            title: '成功',
            message: '成功删除',
            type: 'success',
            duration: 2000
          })
        }).catch(() => {
          this.$notify.error({
            title: '失败',
            message: '删除组织失败'
          })
        })
      }).catch(() => {})
    },
    changeAddEdit () {
      this.getOrgData()
    },
    handleSizeChange (val) {
      this.pageSize = val
    },
    handleCurrentChange (val) {
      this.currentPage = val
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/buildingLayer.vue